import { Component, ViewEncapsulation, ViewChild, ElementRef, Output, Renderer2 } from '@angular/core';
import { Subject } from 'rxjs';

@Component({
    // tslint:disable-next-line:component-selector
    selector: 'cfa-nav-content',
    template: `<div #cfaNavContent (click)="clickBody()" class="cfa-nav-content">
                    <ng-content></ng-content>
                </div>`,
    styleUrls: ['../../styles/styles.scss', './navigation-wrapper.scss'],
    encapsulation: ViewEncapsulation.None
})
// tslint:disable-next-line:component-class-suffix
export class CfaNavContent {
    @ViewChild('cfaNavContent') navContent: ElementRef;

    @Output() bodyClicked: Subject<void> = new Subject();

    constructor(private renderer: Renderer2) { }

    public setCustomHeaderPadding(hasCustomHeader: boolean) {
        if (hasCustomHeader) {
            this.renderer.addClass(this.navContent.nativeElement, 'padForCustomHeader');
        }
    }

    public getNavContent() {
        if (this.navContent) {
            return this.navContent.nativeElement;
        }
    }

    clickBody() {
        this.bodyClicked.next();
    }
}
